<script>
export default {
  props: {
    title: String,
    width: {
      type: [String, Number],
      default: () => 550,
    },
    contentClass: {
      type: String,
      default: () => "",
    },
    persistent: {
      type: Boolean,
      default: () => false,
    },
    hideToolbar: {
      type: Boolean,
      default: () => false,
    },
    loading: Boolean,
    value: Boolean,
  },

  computed: {
    model: {
      get: (vm) => vm.value,
      set(v) {
        this.$emit("input", v);
      },
    },
    hasActions: (vm) => !!vm.$slots.actions,
  },
};
</script>

<template>
  <v-dialog :persistent="persistent" v-model="model" :width="width">
    <v-card :loading="loading" class="modern-card">
      <div v-if="!hideToolbar" class="modern-card-header">
        <h3>{{ title }}</h3>
        <button class="modern-modal-close" @click="model = false" type="button">
          <v-icon size="20">mdi-close</v-icon>
        </button>
      </div>

      <div class="modern-card-body" :class="contentClass">
        <slot />
      </div>

      <div v-if="hasActions" class="modern-card-footer">
        <slot name="actions" />
      </div>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.modern-card.v-card {
  border-radius: 16px !important;
}

.modern-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 12px;
}

.modern-card-header h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: #111318;
}

.modern-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: none;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.15s;
}

.modern-modal-close:hover {
  border-color: #d1d5db;
  background: #f9fafb;
  color: #111318;
}

.modern-card-body {
  padding: 8px 24px 16px;
}

.modern-card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 24px 20px;
}

/* ── Dark mode ── */
.theme--dark .modern-card.v-card {
  background: #1a1b23 !important;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4) !important;
}

.theme--dark .modern-card-header h3 {
  color: #e4e5eb;
}

.theme--dark .modern-modal-close {
  border-color: #2a2c3a;
  color: #8b8d9e;
}

.theme--dark .modern-modal-close:hover {
  border-color: #3a3c4a;
  background: #22232e;
  color: #e4e5eb;
}
</style>
